import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const addCommentQuery = (data) => {
    return axios.post(apiurl?.addComment, data);
};

export default addCommentQuery;
